import getMySipUri from './getMySipUri';
import { addOrUpdatePresence } from '../actions/presenceActions';
import { IO365ShellShim } from '@suiteux/suiteux-shell';
import InstantMessagePresenceType from 'owa-service/lib/contract/InstantMessagePresenceType';
import { trace } from 'owa-trace';
import {
    getOwaPresenceFromInstantMessagePresenceType,
    DefaultMeCardPresences,
} from './utils/suiteHeaderUtils';

export default function updateSelfPresence(newPresence: InstantMessagePresenceType) {
    const presenceObject = getOwaPresenceFromInstantMessagePresenceType(newPresence);
    const o365shell: IO365ShellShim = (window as any).O365Shell;
    if (o365shell && o365shell.MeControl && o365shell.MeControl.SetPresenceStatus) {
        o365shell.MeControl.SetPresenceStatus(presenceObject, DefaultMeCardPresences);
    } else {
        trace.error(
            'OwaUCMAPresenceManagerError: Missing SetPresenceStatus or suite header failed to initialize.'
        );
    }
    addOrUpdatePresence(getMySipUri(), newPresence);
}
